module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "overflow": "hidden !important"
    },
    attrs: {
      "grid-list-xl": "",
      "notificationContainer": ""
    }
  }, [_c('v-form', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewList == true),
      expression: "viewList == true"
    }]
  }, [(_vm.objAuthorize.department_active == 1) ? _c('div', {
    staticStyle: {
      "float": "left",
      "width": "25%"
    }
  }, [_c('v-select', {
    staticClass: "shortSelect",
    attrs: {
      "items": _vm.notificationDepartmentList,
      "item-text": "name",
      "item-value": "id",
      "solo": "",
      "outline": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncFilterNotifications()
      }
    },
    model: {
      value: (_vm.subDepartmentFilter),
      callback: function($$v) {
        _vm.subDepartmentFilter = $$v
      },
      expression: "subDepartmentFilter"
    }
  }), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncToggleDisplay()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v("Add New Notification")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "loading": "true",
      "headers": _vm.notificationHeader,
      "items": _vm.notificationListSet,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "sortableRow"
        }, [_c('td', {
          attrs: {
            "width": "35%"
          }
        }, [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), (props.item.departments == '' || props.item.departments == '0' || props.item.departments == null) ? _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_vm._v("N/A")]) : _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('v-tooltip', {
          staticStyle: {
            "top": "0px !important"
          },
          attrs: {
            "bottom": ""
          }
        }, [_c('p', {
          staticStyle: {
            "cursor": "pointer",
            "padding-top": "14px",
            "float": "left",
            "display": "block"
          },
          attrs: {
            "slot": "activator"
          },
          slot: "activator"
        }, [_vm._v("View Departments")]), _vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.fncGetDepartment(props.item.departments))
          }
        })])], 1), _vm._v(" "), _c('td', {
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(_vm.fncGetType(props.item.type_id)))]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditNotification(props.index)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])])]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "10%"
          }
        }, [_c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDeleteNotifications(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete_forever")])])]), _vm._v(" "), _c('td', {
          attrs: {
            "width": "15%"
          }
        }, [_c('v-switch', {
          on: {
            "change": function($event) {
              return _vm.fncChangeState(props.item.id, props.item.state)
            }
          },
          model: {
            value: (props.item.state),
            callback: function($$v) {
              _vm.$set(props.item, "state", $$v)
            },
            expression: "props.item.state"
          }
        })], 1)])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.viewList == false) ? _c('v-flex', {
    staticStyle: {
      "padding-left": "0px !important"
    },
    attrs: {
      "lg12": ""
    }
  }, [(_vm.notificationId !== '') ? _c('v-btn', {
    staticClass: "text-xs-right floatLeft importantButton",
    attrs: {
      "disabled": _vm.fncCheckNotificationAction()
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncUpdateNotification()
      }
    }
  }, [_vm._v("Update")]) : _vm._e(), _vm._v(" "), (_vm.notificationId === '') ? _c('v-btn', {
    staticClass: "importantButton text-xs-right floatLeft",
    attrs: {
      "disabled": _vm.fncCheckNotificationAction()
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncAddNotification()
      }
    }
  }, [_vm._v("Add")]) : _vm._e(), _vm._v(" "), _c('small', {
    staticStyle: {
      "padding-top": "16px",
      "display": "block",
      "padding-left": "12px",
      "float": "left"
    }
  }, [_vm._v("* Button will activate when all * COMPULSORY fields have been filled in")])], 1) : _vm._e(), _vm._v(" "), _c('v-tabs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.viewList == false),
      expression: "viewList == false"
    }],
    key: _vm.notificationFormKey,
    staticClass: "notificationsTabs",
    attrs: {
      "slider-color": "grey"
    }
  }, [_c('v-tab', {
    key: 1,
    ref: "startTab",
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("General")]), _vm._v(" "), (_vm.fncCheckMethodList('email') && (this.notifyRep == true || this.notifyVendor == true || this.notifyVendor == false || this.notifyOriginator == true || this.notifyKam == true || this.notifyCoordinator == true)) ? _c('v-tab', {
    key: 2,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Internal Email")]) : _c('v-tab', {
    key: 2,
    staticClass: "tab",
    attrs: {
      "disabled": "",
      "ripple": ""
    }
  }, [_vm._v("Internal Email")]), _vm._v(" "), (_vm.fncCheckMethodList('sms') && _vm.notifyDaily == false && (this.notifyRep == true || this.notifyVendor == true || this.notifyOriginator == true || this.notifyKam == true || this.notifyCoordinator == true)) ? _c('v-tab', {
    key: 3,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Internal Whatsapp")]) : _c('v-tab', {
    key: 3,
    staticClass: "tab",
    attrs: {
      "disabled": "",
      "ripple": ""
    }
  }, [_vm._v("Internal Whatsapp")]), _vm._v(" "), (_vm.fncCheckMethodList('email') && _vm.notifyCustomer == true && _vm.notifyDaily == false) ? _c('v-tab', {
    key: 4,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Customer Email")]) : _c('v-tab', {
    key: 4,
    staticClass: "tab",
    attrs: {
      "disabled": "",
      "ripple": ""
    }
  }, [_vm._v("Customer Email")]), _vm._v(" "), (_vm.fncCheckMethodList('sms') && _vm.notifyCustomer == true && _vm.notifyDaily == false) ? _c('v-tab', {
    key: 5,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("Customer Whatsapp")]) : _c('v-tab', {
    key: 5,
    staticClass: "tab",
    attrs: {
      "disabled": "",
      "ripple": ""
    }
  }, [_vm._v("Customer Whatsapp")]), _vm._v(" "), (_vm.apiData.isApi == true || _vm.apiData.isApi == 'true') ? _c('v-tab', {
    key: 6,
    staticClass: "tab",
    attrs: {
      "ripple": ""
    }
  }, [_vm._v("API")]) : _vm._e(), _vm._v(" "), _c('v-tab-item', {
    key: 1,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "0px !important",
      "height": "60vh",
      "padding-bottom": "40px !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.objAuthorize.email == 'superuser@ndtec.co.za' || _vm.objAuthorize.email == 'bwsuperuser@ndtec.co.za') ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("API call:")]), _vm._v(" "), _c('small', [_vm._v("Is this an API call?")]), _vm._v(" "), _c('v-switch', {
    model: {
      value: (_vm.apiData.isApi),
      callback: function($$v) {
        _vm.$set(_vm.apiData, "isApi", $$v)
      },
      expression: "apiData.isApi"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Notification Name:")]), _vm._v(" "), _c('small', [_vm._v("Provide a unique description for this Notification")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Notification Name",
      "single-line": "",
      "solo": ""
    },
    on: {
      "input": function($event) {
        return _vm.fncSetModalTitle()
      }
    },
    model: {
      value: (_vm.notificationName),
      callback: function($$v) {
        _vm.notificationName = $$v
      },
      expression: "notificationName"
    }
  })], 1), _vm._v(" "), (_vm.apiData.isApi == false) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Notification Type:")]), _vm._v(" "), _c('small', [_vm._v("How do you want Notifications to be triggered")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.notificationTypes,
      "placeholder": "Notification Type",
      "item-value": "id",
      "item-text": "name",
      "solo": ""
    },
    on: {
      "input": _vm.fncCheckType
    },
    model: {
      value: (_vm.notificationType),
      callback: function($$v) {
        _vm.notificationType = $$v
      },
      expression: "notificationType"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.notificationType == 3) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Notification Status From:")]), _vm._v(" "), _c('small', [_vm._v("From what status would you like notifications?")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.statusList,
      "placeholder": "Notification Status From",
      "item-value": "id",
      "item-text": "description",
      "autocomplete": "",
      "solo": ""
    },
    model: {
      value: (_vm.notifyStatusStatus),
      callback: function($$v) {
        _vm.notifyStatusStatus = $$v
      },
      expression: "notifyStatusStatus"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notificationType == 3),
      expression: "notificationType == 3"
    }],
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Number of Days of non change:")]), _vm._v(" "), _c('small', [_vm._v("Trigger notification after how many days of no change in status?")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Days",
      "type": "number",
      "min": "0",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.notifyStatusDays),
      callback: function($$v) {
        _vm.notifyStatusDays = $$v
      },
      expression: "notifyStatusDays"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notificationType == 3),
      expression: "notificationType == 3"
    }],
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Number of Hours of non change:")]), _vm._v(" "), _c('small', [_vm._v("And/or how many hours?")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Hours",
      "type": "number",
      "min": "0",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.notifyStatusHours),
      callback: function($$v) {
        _vm.notifyStatusHours = $$v
      },
      expression: "notifyStatusHours"
    }
  })], 1), _vm._v(" "), (_vm.apiData.isApi == false) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Notification Timing:")]), _vm._v(" "), _c('small', [_vm._v("When should this notification be sent?")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.notificationReportTypes,
      "placeholder": "Notification Report Type",
      "item-value": "id",
      "item-text": "name",
      "solo": ""
    },
    on: {
      "input": _vm.fncCheckDaily
    },
    model: {
      value: (_vm.notifyDaily),
      callback: function($$v) {
        _vm.notifyDaily = $$v
      },
      expression: "notifyDaily"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notifyDaily == true),
      expression: "notifyDaily ==  true"
    }],
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Notification Time:")]), _vm._v(" "), _c('small', [_vm._v("When should the notification be sent")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.notificationTimes,
      "placeholder": "Notification Time",
      "item-value": "id",
      "item-text": "name",
      "solo": ""
    },
    model: {
      value: (_vm.notificationTime),
      callback: function($$v) {
        _vm.notificationTime = $$v
      },
      expression: "notificationTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.notifyDaily == true || _vm.notificationType == 2) && _vm.notificationType != 3),
      expression: "( notifyDaily == true || notificationType == 2 ) && notificationType != 3"
    }],
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Number of Days:")]), _vm._v(" "), (this.notificationType == 2) ? _c('small', [_vm._v("Trigger notification after how many days of no change in status?")]) : _vm._e(), _vm._v(" "), (this.notificationType == 1) ? _c('small', [_vm._v("Include quotes that were changed to status in the last how many day/s")]) : _vm._e(), _vm._v(" "), (this.notificationType == '') ? _c('small', [_vm._v("-")]) : _vm._e(), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Days",
      "type": "number",
      "min": "0",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.notificationDays),
      callback: function($$v) {
        _vm.notificationDays = $$v
      },
      expression: "notificationDays"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.notifyDaily == true || _vm.notificationType == 2) && _vm.notificationType != 3),
      expression: "( notifyDaily == true || notificationType == 2 ) && notificationType != 3"
    }],
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Number of Hours:")]), _vm._v(" "), _c('small', [_vm._v("And/or how many hours?")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Hours",
      "type": "number",
      "min": "0",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.notificationHours),
      callback: function($$v) {
        _vm.notificationHours = $$v
      },
      expression: "notificationHours"
    }
  })], 1), _vm._v(" "), (this.notifyRep == true && _vm.apiData.isApi == false) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Who needs to be notified?")]), _vm._v(" "), _c('small', [_vm._v("\n                    Select " + _vm._s(_vm.objAuthorize.manu_user_alias) + " roles to be notified\n                  "), _c('v-tooltip', {
    staticStyle: {
      "top": "0px !important"
    },
    attrs: {
      "left": ""
    }
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "display": "inline-block",
      "font-size": "16px",
      "float": "right",
      "margin-top": "-18px",
      "margin-right": "8px"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("info")]), _vm._v(" "), _c('span', [_vm._v("Select " + _vm._s(_vm.objAuthorize.manu_user_alias) + " roles to be notified, that are also linked to the departments selected in the \"Notification Department\" section")])])], 1), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.filteredUserTypes,
      "placeholder": "Notification Roles",
      "item-value": "id",
      "item-text": "name",
      "multiple": "",
      "outline": "",
      "autocomplete": ""
    },
    on: {
      "input": _vm.fncCheckForVendor
    },
    model: {
      value: (_vm.notificationRole),
      callback: function($$v) {
        _vm.notificationRole = $$v
      },
      expression: "notificationRole"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.apiData.isApi == false && _vm.notifyDaily == false) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("If this role is present do not send this notification at all")]), _vm._v(" "), _c('small', [_vm._v("\n                  If a User with the below Role is linked to quote, don’t sent this notification for that quote\n                ")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.filteredUserTypes,
      "placeholder": "Notification Roles To Ignore",
      "item-value": "id",
      "item-text": "name",
      "multiple": "",
      "outline": "",
      "autocomplete": ""
    },
    model: {
      value: (_vm.notificationRoleIgnore),
      callback: function($$v) {
        _vm.notificationRoleIgnore = $$v
      },
      expression: "notificationRoleIgnore"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.apiData.isApi == false && _vm.notifyDaily == true) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Notification Per Store:")]), _vm._v(" "), _c('small', [_vm._v("Should users only receive store related quotes")]), _vm._v(" "), _c('v-switch', {
    model: {
      value: (_vm.notifyIsStore),
      callback: function($$v) {
        _vm.notifyIsStore = $$v
      },
      expression: "notifyIsStore"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.apiData.isApi == false && _vm.notifyDaily == true),
      expression: "apiData.isApi == false && notifyDaily == true"
    }],
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Notification Days:")]), _vm._v(" "), _c('small', [_vm._v("What days do you want to send notification on")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.notificationSendDaysItems,
      "placeholder": "Notification Days",
      "item-value": "id",
      "item-text": "name",
      "multiple": "",
      "outline": ""
    },
    model: {
      value: (_vm.notificationSendDays),
      callback: function($$v) {
        _vm.notificationSendDays = $$v
      },
      expression: "notificationSendDays"
    }
  })], 1), _vm._v(" "), (_vm.apiData.isApi == false) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Notification Method:")]), _vm._v(" "), _c('small', [_vm._v("How do you want to send the notification")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.notificationMethods,
      "placeholder": "Notification Method",
      "item-value": "id",
      "item-text": "name",
      "multiple": "",
      "outline": ""
    },
    model: {
      value: (_vm.notificationMethod),
      callback: function($$v) {
        _vm.notificationMethod = $$v
      },
      expression: "notificationMethod"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.apiData.isApi == false) ? _c('v-flex', {
    staticClass: "noArrows",
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Quote Value Threshold (incl of VAT):")]), _vm._v(" "), _c('small', [_vm._v("Quotes under this value will be Ignored")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Quote Value",
      "type": "number",
      "min": "0",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.notificationValue),
      callback: function($$v) {
        _vm.notificationValue = $$v
      },
      expression: "notificationValue"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.apiData.isApi == false) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Exclude Quotes Generated More Than")]), _vm._v(" "), _c('small', [_vm._v("Number of days ago")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Quote Value",
      "type": "number",
      "min": "0",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.notificationAge),
      callback: function($$v) {
        _vm.notificationAge = $$v
      },
      expression: "notificationAge"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.apiData.isApi == false) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Direct Reports")]), _vm._v(" "), _c('small', [_vm._v("Email the report to a specific user")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.repUsers,
      "placeholder": "Direct Report",
      "item-value": "id",
      "item-text": "label",
      "solo": "",
      "multiple": "",
      "autocomplete": ""
    },
    model: {
      value: (_vm.notificationDirectReport),
      callback: function($$v) {
        _vm.notificationDirectReport = $$v
      },
      expression: "notificationDirectReport"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notifyDaily == false && _vm.apiData.isApi == false),
      expression: "notifyDaily == false && apiData.isApi == false"
    }],
    staticClass: "greenDot",
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Notify " + _vm._s(_vm.objAuthorize.manu_user_alias) + " roles:")]), _vm._v(" "), _c('small', [_vm._v("Send the rep a message as well")]), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": _vm.fncGetRepFlag()
    },
    on: {
      "change": function($event) {
        return _vm.fncCheckRoles()
      }
    },
    model: {
      value: (_vm.notifyRep),
      callback: function($$v) {
        _vm.notifyRep = $$v
      },
      expression: "notifyRep"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notifyDaily == false && _vm.apiData.isApi == false),
      expression: "notifyDaily == false && apiData.isApi == false"
    }],
    staticClass: "greenDot",
    attrs: {
      "lg3": ""
    }
  }, [(_vm.notifyDaily == false) ? _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Notify Customer:")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily == false) ? _c('small', [_vm._v("Send the customer a message as well")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily == false) ? _c('v-switch', {
    attrs: {
      "label": _vm.fncGetCustomerFlag()
    },
    model: {
      value: (_vm.notifyCustomer),
      callback: function($$v) {
        _vm.notifyCustomer = $$v
      },
      expression: "notifyCustomer"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notifyDaily == false && _vm.apiData.isApi == false),
      expression: "notifyDaily == false && apiData.isApi == false"
    }],
    staticClass: "greenDot",
    attrs: {
      "lg3": ""
    }
  }, [(_vm.notifyDaily == false) ? _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Notify Vendor:")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily == false) ? _c('small', [_vm._v("Send the vendor a message as well")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily == false) ? _c('v-switch', {
    on: {
      "change": function($event) {
        return _vm.notifyVendorEventListener($event)
      }
    },
    model: {
      value: (_vm.notifyVendor),
      callback: function($$v) {
        _vm.notifyVendor = $$v
      },
      expression: "notifyVendor"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notifyDaily == false && _vm.apiData.isApi == false),
      expression: "notifyDaily == false && apiData.isApi == false"
    }],
    staticClass: "greenDot",
    attrs: {
      "lg3": ""
    }
  }, [(_vm.notifyDaily == false) ? _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Notify Originator:")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily == false) ? _c('small', [_vm._v("Send the originator a message as well")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily == false) ? _c('v-switch', {
    model: {
      value: (_vm.notifyOriginator),
      callback: function($$v) {
        _vm.notifyOriginator = $$v
      },
      expression: "notifyOriginator"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notifyDaily == false && _vm.apiData.isApi == false),
      expression: "notifyDaily == false && apiData.isApi == false"
    }],
    staticClass: "greenDot",
    attrs: {
      "lg3": ""
    }
  }, [(_vm.notifyDaily == false) ? _c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Is this a Call Out Notification:")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily == false) ? _c('small', [_vm._v("Send if it is a callout quote")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily == false) ? _c('v-switch', {
    model: {
      value: (_vm.isCallout),
      callback: function($$v) {
        _vm.isCallout = $$v
      },
      expression: "isCallout"
    }
  }) : _vm._e()], 1), _vm._v(" "), (this.notifyVendor == true && _vm.apiData.isApi == false) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Vendor roles needs to be notified?")]), _vm._v(" "), _c('small', [_vm._v("Select vendor roles to be notified")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.filteredUserTypesVendors,
      "placeholder": "Notification Roles",
      "item-value": "id",
      "item-text": "name",
      "multiple": "",
      "outline": "",
      "autocomplete": ""
    },
    on: {
      "input": _vm.fncCheckForVendor
    },
    model: {
      value: (_vm.notificationRole),
      callback: function($$v) {
        _vm.notificationRole = $$v
      },
      expression: "notificationRole"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.hasVendorRole == true && _vm.vendorManufacturerLinks.length > 0) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Vendors to Notify:")]), _vm._v(" "), _c('small', [_vm._v("Notify which Vendors")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.vendorManufacturerLinks,
      "placeholder": "Vendors to Notify",
      "item-value": "id",
      "item-text": "name",
      "autocomplete": "",
      "multiple": "",
      "outline": "",
      "autocomplete": ""
    },
    on: {
      "input": _vm.fncCheckVendors
    },
    model: {
      value: (_vm.notificationVendors),
      callback: function($$v) {
        _vm.notificationVendors = $$v
      },
      expression: "notificationVendors"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.branch_active == true && _vm.branchList.length > 0 && _vm.apiData.isApi == false) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Notification Store:")]), _vm._v(" "), _c('small', [_vm._v("Send the notification for specific stores")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.branchList,
      "placeholder": "Notification Stores",
      "item-value": "id",
      "item-text": "name",
      "solo": "",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "input": _vm.fncCheckBranches
    },
    model: {
      value: (_vm.notificationBranches),
      callback: function($$v) {
        _vm.notificationBranches = $$v
      },
      expression: "notificationBranches"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.department_active == true && _vm.departmentList.length > 0 && _vm.apiData.isApi == false) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Notification Department:")]), _vm._v(" "), _c('small', [_vm._v("Send the notification for specific departments")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.departmentListSet,
      "placeholder": "Notification Departments",
      "item-value": "id",
      "item-text": "name",
      "solo": "",
      "multiple": "",
      "autocomplete": ""
    },
    on: {
      "input": _vm.fncCheckDepartments
    },
    model: {
      value: (_vm.notificationDepartments),
      callback: function($$v) {
        _vm.notificationDepartments = $$v
      },
      expression: "notificationDepartments"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.vendorManufacturerLinks.length > 0 && _vm.apiData.isApi == false) ? _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Notification Report Vendors:")]), _vm._v(" "), _c('small', [_vm._v("Show quotes to Builders users for selected Vendors")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.vendorManufacturerLinks,
      "placeholder": "Notification Vendors",
      "item-value": "id",
      "item-text": "name",
      "solo": "",
      "multiple": "",
      "autocomplete": ""
    },
    model: {
      value: (_vm.notificationReportVendors),
      callback: function($$v) {
        _vm.notificationReportVendors = $$v
      },
      expression: "notificationReportVendors"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notifyDaily == false && _vm.apiData.isApi == false),
      expression: "notifyDaily == false && apiData.isApi == false"
    }],
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Notification Quote Type:")]), _vm._v(" "), _c('small', [_vm._v("Send notification for specific quote type")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.quoteTypes,
      "placeholder": "Notification Quote Type",
      "item-value": "id",
      "item-text": "name",
      "solo": "",
      "autocomplete": ""
    },
    model: {
      value: (_vm.notificationQuoteType),
      callback: function($$v) {
        _vm.notificationQuoteType = $$v
      },
      expression: "notificationQuoteType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notifyDaily == false && _vm.apiData.isApi == false),
      expression: "notifyDaily == false && apiData.isApi == false"
    }],
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Notification Service Type:")]), _vm._v(" "), _c('small', [_vm._v("Send notification for specific service type")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.serviceTypes,
      "placeholder": "Notification Quote Type",
      "item-value": "id",
      "item-text": "name",
      "solo": "",
      "autocomplete": ""
    },
    model: {
      value: (_vm.notificationServiceType),
      callback: function($$v) {
        _vm.notificationServiceType = $$v
      },
      expression: "notificationServiceType"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 2,
    staticClass: "pl-4 pr-4 pt-4 pb-4",
    staticStyle: {
      "overflow": "hidden !important"
    }
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "0px !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fncCheckMethodList('email')),
      expression: "!fncCheckMethodList('email')"
    }]
  }, [_c('br'), _c('strong', [_vm._v("Please select a Notification Method under the General Tab to enable this screen.")])]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fncCheckMethodList('email')),
      expression: "fncCheckMethodList('email')"
    }],
    staticStyle: {
      "padding-top": "0px !important",
      "padding-bottom": "0px !important",
      "overflow": "hidden !important"
    },
    attrs: {
      "lg4": ""
    }
  }, [(_vm.notifyDaily === false) ? _c('v-switch', {
    staticClass: "switchSmall pdfSwitch",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "label": "Attach the quote PDF"
    },
    model: {
      value: (_vm.notifyAddPdf),
      callback: function($$v) {
        _vm.notifyAddPdf = $$v
      },
      expression: "notifyAddPdf"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false && _vm.objAuthorize.po_template != '') ? _c('v-switch', {
    staticClass: "switchSmall pdfSwitch",
    staticStyle: {
      "margin-top": "-6px"
    },
    attrs: {
      "label": "Attach the Purchase Order PDF"
    },
    model: {
      value: (_vm.notifyAddPoPdfVendor),
      callback: function($$v) {
        _vm.notifyAddPoPdfVendor = $$v
      },
      expression: "notifyAddPoPdfVendor"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "shortcodes"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "12px !important"
    }
  }, [_vm._v("Originator Details")]), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Sales Rep's first name to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[REP_NAME]', 'rep')
      }
    }
  }, [_vm._v("[REP_NAME]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Sales Rep's surname to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[REP_SURNAME]', 'rep')
      }
    }
  }, [_vm._v("[REP_SURNAME]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Sales Rep's email address to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[REP_EMAIL]', 'rep')
      }
    }
  }, [_vm._v("[REP_EMAIL]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Sales Rep's telephone number to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[REP_TEL]', 'rep')
      }
    }
  }, [_vm._v("[REP_TEL]")]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add your business name to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[YOUR_COMPANY_NAME]', 'rep')
      }
    }
  }, [_vm._v("[YOUR_COMPANY_NAME]")])]), _vm._v(" "), _c('div', {
    staticClass: "shortcodes"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "12px !important"
    }
  }, [_vm._v("Customer Details")]), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Customer's first name to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[CUSTOMER_NAME]', 'rep')
      }
    }
  }, [_vm._v("[CUSTOMER_NAME]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Customer's surname to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[CUSTOMER_SURNAME]', 'rep')
      }
    }
  }, [_vm._v("[CUSTOMER_SURNAME]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Customer's email address to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[CUSTOMER_EMAIL]', 'rep')
      }
    }
  }, [_vm._v("[CUSTOMER_EMAIL]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Customer's telephone number to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[CUSTOMER_TEL]', 'rep')
      }
    }
  }, [_vm._v("[CUSTOMER_TEL]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Customer's company to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[CUSTOMER_COMPANY]', 'rep')
      }
    }
  }, [_vm._v("[CUSTOMER_COMPANY]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Customer's Delivery Details to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[CUSTOMER_DELIVERY_DETAILS]', 'rep')
      }
    }
  }, [_vm._v("[CUSTOMER_DELIVERY_DETAILS]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Customer Recipient to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_CUSTOMER_RECIPIENT]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_CUSTOMER_RECIPIENT]")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "shortcodes"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "12px !important",
      "margin-top": "20px !important"
    }
  }, [_vm._v("Recipient Details")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": _vm.fncRecName()
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[RECIPIENT_NAME]', 'rep')
      }
    }
  }, [_vm._v("[RECIPIENT_NAME]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": _vm.fncRecSurname()
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[RECIPIENT_SURNAME]', 'rep')
      }
    }
  }, [_vm._v("[RECIPIENT_SURNAME]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": _vm.fncRecEmail()
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[RECIPIENT_EMAIL]', 'rep')
      }
    }
  }, [_vm._v("[RECIPIENT_EMAIL]")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-size": "12px !important",
      "margin-top": "20px !important"
    }
  }, [_vm._v("Quote Details")]), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the direct link to the quote"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_DIRECT_LINK]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_DIRECT_LINK]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the direct link to the quote"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_DIRECT_LINK_PURCHASE_ORDER]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_DIRECT_LINK_PURCHASE_ORDER]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the sales order number"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[SALES_ORDER_NUMBER]', 'rep')
      }
    }
  }, [_vm._v("[SALES_ORDER_NUMBER]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the store to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_STORE]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_STORE]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the reason for status"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_STATUS_REASON]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_STATUS_REASON]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the time the status has not changed"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_TIME_IN_STATUS]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_TIME_IN_STATUS]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Service Form type"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[SERVICE_TYPE]', 'rep')
      }
    }
  }, [_vm._v("[SERVICE_TYPE]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Project"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[PROJECT]', 'rep')
      }
    }
  }, [_vm._v("[PROJECT]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Department"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[DEPARTMENT]', 'rep')
      }
    }
  }, [_vm._v("[DEPARTMENT]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Notes"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[NOTES]', 'rep')
      }
    }
  }, [_vm._v("[NOTES]")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "shortcodes"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "12px !important",
      "margin-top": "20px !important"
    }
  }, [_vm._v("Quote Details")]), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the quote date to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_DATE]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_DATE]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the quote number to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_NO]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_NO]")]) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the current quote status to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_STATUS]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_STATUS]")]), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add a summary of the quote to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_SUMMARY]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_SUMMARY]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the quote vat total to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_TOTAL_VATEXCL]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_TOTAL_VATEXCL]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the quote total including vat to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_TOTAL_VATINCL]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_TOTAL_VATINCL]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add buttons for the customer to Accept/Reject a quote to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_ACCEPT_REJECT]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_ACCEPT_REJECT]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the sales order number to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_SO_NUMBER]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_SO_NUMBER]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the purchase order number to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_PO_NUMBER]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_PO_NUMBER]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Transaction ID"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[TRANSACTION_ID]', 'rep')
      }
    }
  }, [_vm._v("[TRANSACTION_ID]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Shipping Tracking Number"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[SHIPPING_TRACKING_NO]', 'rep')
      }
    }
  }, [_vm._v("[SHIPPING_TRACKING_NO]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Shipping Tracking URL"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[SHIPPING_TRACKING_URL]', 'rep')
      }
    }
  }, [_vm._v("[SHIPPING_TRACKING_URL]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Shipping Date / Time"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[SHIPPING_DATE_TIME]', 'rep')
      }
    }
  }, [_vm._v("[SHIPPING_DATE_TIME]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Company"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[COMPANY]', 'rep')
      }
    }
  }, [_vm._v("[COMPANY]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the list of linked quotes"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[LINKED_QUOTES]', 'rep')
      }
    }
  }, [_vm._v("[LINKED_QUOTES]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the list of linked quotes"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[SERVICE_FORM_REASON]', 'rep')
      }
    }
  }, [_vm._v("[SERVICE_FORM_REASON]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add Quote Memo"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_MEMO]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_MEMO]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add Quote External Ref"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_EXTERNAL_REF]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_EXTERNAL_REF]")]) : _vm._e()])], 1), _vm._v(" "), (_vm.fncCheckMethodList('email') && this.internalEmailPreview == false) ? _c('v-flex', {
    staticStyle: {
      "padding-bottom": "0px !important"
    },
    attrs: {
      "lg6": "",
      "id": "reps"
    }
  }, [_c('label', {
    staticClass: "blackLabel",
    staticStyle: {
      "display": "block",
      "float": "left",
      "width": "10% !important",
      "padding-top": "10px"
    }
  }, [_vm._v("* Subject:")]), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "display": "block",
      "float": "left",
      "width": "45% !important"
    },
    attrs: {
      "placeholder": "Subject",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.notificationSubject),
      callback: function($$v) {
        _vm.notificationSubject = $$v
      },
      expression: "notificationSubject"
    }
  }), _vm._v(" "), _c('small', {
    staticStyle: {
      "display": "block",
      "float": "left",
      "width": "30% !important",
      "padding-top": "12px !important"
    }
  }, [_vm._v("  Subject line of the Email")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "blackLabel",
    staticStyle: {
      "margin-top": "20px !important"
    }
  }, [_vm._v("* Create Message Text:")]), _vm._v(" "), _c('small', [_vm._v("Set up the message that will be sent to the selected internal roles.  Insert the shortcode variables into your message template by clicking on them from the desired part of your text. "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "cursor": "pointer",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncShowInternalEmailPreview(true)
      }
    }
  }, [_vm._v("VIEW EXAMPLE")])]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CAN_PASTE_NOTIFICATIONS') == -1) ? _c('v-text-field', {
    attrs: {
      "rows": "10",
      "placeholder": "Rep Email Text",
      "id": "repText",
      "multi-line": "",
      "solo": ""
    },
    on: {
      "focus": function($event) {
        return _vm.fncDisablePaste()
      }
    },
    model: {
      value: (_vm.repWysiwig),
      callback: function($$v) {
        _vm.repWysiwig = $$v
      },
      expression: "repWysiwig"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CAN_PASTE_NOTIFICATIONS') != -1) ? _c('v-text-field', {
    attrs: {
      "rows": "10",
      "placeholder": "Rep Email Text",
      "id": "repText",
      "multi-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.repWysiwig),
      callback: function($$v) {
        _vm.repWysiwig = $$v
      },
      expression: "repWysiwig"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.fncCheckMethodList('email') && this.internalEmailPreview == true) ? _c('v-flex', {
    attrs: {
      "lg7": ""
    }
  }, [_c('small', [_c('span', {
    staticStyle: {
      "display": "block !important",
      "float": "left !important"
    }
  }, [_vm._v("Message that will be sent to selected internal roles ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5px !important",
      "font-weight": "bold",
      "cursor": "pointer",
      "text-decoration": "underline",
      "display": "block !important",
      "float": "left !important"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncShowInternalEmailPreview(false)
      }
    }
  }, [_vm._v("HIDE EXAMPLE")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "white-space": "pre-line !important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fncContentInternalEmail())
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "12px !important",
      "margin-top": "0px !important"
    }
  }, [_vm._v("Add Attachment Categories")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.attachmentCategories,
      "placeholder": "Notification Attachment Categories",
      "item-value": "id",
      "item-text": "name",
      "multiple": "",
      "outline": ""
    },
    model: {
      value: (_vm.notificationCats),
      callback: function($$v) {
        _vm.notificationCats = $$v
      },
      expression: "notificationCats"
    }
  }), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-size": "12px !important",
      "margin-top": "00px !important"
    }
  }, [_vm._v("Add Roles Shortcode")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.userRoles,
      "placeholder": "Notification User Roles",
      "item-value": "id",
      "item-text": "name",
      "solo": ""
    },
    on: {
      "input": _vm.fncSetRole
    },
    model: {
      value: (_vm.shortRole),
      callback: function($$v) {
        _vm.shortRole = $$v
      },
      expression: "shortRole"
    }
  }), _vm._v(" "), _c('br'), _c('h3', {
    staticStyle: {
      "font-size": "12px !important",
      "margin-top": "00px !important"
    }
  }, [_vm._v("Add Status Button")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.statusList,
      "placeholder": "Notification Status Button",
      "item-value": "id",
      "item-text": "description",
      "solo": ""
    },
    on: {
      "input": _vm.fncSetStatus
    },
    model: {
      value: (_vm.shortStatus),
      callback: function($$v) {
        _vm.shortStatus = $$v
      },
      expression: "shortStatus"
    }
  }), _vm._v(" "), _c('br'), (_vm.notifyDaily === false) ? _c('v-switch', {
    staticClass: "switchSmall pdfSwitch",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "label": "Attach the full service form"
    },
    model: {
      value: (_vm.attachServiceFormFull),
      callback: function($$v) {
        _vm.attachServiceFormFull = $$v
      },
      expression: "attachServiceFormFull"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('v-switch', {
    staticClass: "switchSmall pdfSwitch",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "label": "Attach the customer service form"
    },
    model: {
      value: (_vm.attachServiceFormClient),
      callback: function($$v) {
        _vm.attachServiceFormClient = $$v
      },
      expression: "attachServiceFormClient"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('v-switch', {
    staticClass: "switchSmall pdfSwitch",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "label": "Attach Delivery Note"
    },
    model: {
      value: (_vm.attachDeliveryNote),
      callback: function($$v) {
        _vm.attachDeliveryNote = $$v
      },
      expression: "attachDeliveryNote"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 3,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "0px !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fncCheckMethodList('sms') || _vm.notifyDaily == true),
      expression: "!fncCheckMethodList('sms') || notifyDaily == true"
    }]
  }, [_c('br'), _c('strong', [_vm._v("Please select a Notification Method under the General Tab to enable this screen.")])]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fncCheckMethodList('sms') && _vm.notifyDaily == false),
      expression: "fncCheckMethodList('sms') && notifyDaily == false"
    }],
    staticStyle: {
      "overflow": "hidden !important"
    },
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Usable Shortcodes:")]), _vm._v(" "), _c('div', {
    staticClass: "shortcodes"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "12px !important"
    }
  }, [_vm._v("Originator Details")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Sales Rep's first name to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[REP_NAME]', 'rep')
      }
    }
  }, [_vm._v("[REP_NAME]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Sales Rep's surname to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[REP_SURNAME]', 'rep')
      }
    }
  }, [_vm._v("[REP_SURNAME]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Sales Rep's email address to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[REP_EMAIL]', 'rep')
      }
    }
  }, [_vm._v("[REP_EMAIL]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Sales Rep's telephone number to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[REP_TEL]', 'rep')
      }
    }
  }, [_vm._v("[REP_TEL]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add your business name to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[YOUR_COMPANY_NAME]', 'rep')
      }
    }
  }, [_vm._v("[YOUR_COMPANY_NAME]")])]), _vm._v(" "), _c('div', {
    staticClass: "shortcodes"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "12px !important"
    }
  }, [_vm._v("Customer Details")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Customer's first name to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[CUSTOMER_NAME]', 'rep')
      }
    }
  }, [_vm._v("[CUSTOMER_NAME]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Customer's surname to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[CUSTOMER_SURNAME]', 'rep')
      }
    }
  }, [_vm._v("[CUSTOMER_SURNAME]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Customer's email address to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[CUSTOMER_EMAIL]', 'rep')
      }
    }
  }, [_vm._v("[CUSTOMER_EMAIL]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Customer's telephone number to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[CUSTOMER_TEL]', 'rep')
      }
    }
  }, [_vm._v("[CUSTOMER_TEL]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Customer's company to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[CUSTOMER_COMPANY]', 'rep')
      }
    }
  }, [_vm._v("[CUSTOMER_COMPANY]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Customer's Delivery Details to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[CUSTOMER_DELIVERY_DETAILS]', 'rep')
      }
    }
  }, [_vm._v("[CUSTOMER_DELIVERY_DETAILS]")])]), _vm._v(" "), _c('div', {
    staticClass: "shortcodes"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "12px !important",
      "margin-top": "20px !important"
    }
  }, [_vm._v("Recipient Details")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": _vm.fncRecName()
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[RECIPIENT_NAME]', 'rep')
      }
    }
  }, [_vm._v("[RECIPIENT_NAME]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": _vm.fncRecSurname()
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[RECIPIENT_SURNAME]', 'rep')
      }
    }
  }, [_vm._v("[RECIPIENT_SURNAME]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": _vm.fncRecEmail()
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[RECIPIENT_EMAIL]', 'rep')
      }
    }
  }, [_vm._v("[RECIPIENT_EMAIL]")])]), _vm._v(" "), _c('div', {
    staticClass: "shortcodes"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "12px !important",
      "margin-top": "20px !important"
    }
  }, [_vm._v("Quote Details")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the quote date to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[QUOTE_DATE]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_DATE]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the quote number to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[QUOTE_NO]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_NO]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the current quote status to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[QUOTE_STATUS]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_STATUS]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the quote vat total to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[QUOTE_TOTAL_VATEXCL]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_TOTAL_VATEXCL]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the quote total including vat to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[QUOTE_TOTAL_VATINCL]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_TOTAL_VATINCL]")]), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add Quote Memo"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_MEMO]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_MEMO]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add Quote External Ref"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_EXTERNAL_REF]', 'rep')
      }
    }
  }, [_vm._v("[QUOTE_EXTERNAL_REF]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add Quote PDF Download Button"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[DOWNLOAD_BUTTON]', 'rep')
      }
    }
  }, [_vm._v("[DOWNLOAD_BUTTON]")]) : _vm._e()])]), _vm._v(" "), (_vm.fncCheckMethodList('sms') && _vm.notifyDaily == false && this.internalSmsPreview == false) ? _c('v-flex', {
    attrs: {
      "lg8": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Create Whatsapp Message:")]), _c('br'), _vm._v(" "), _c('label', [_vm._v("Select Whatsapp Template")]), _vm._v(" "), _c('v-select', {
    staticClass: "shortSelect",
    attrs: {
      "placeholder": "Select Whatsapp Template",
      "items": _vm.whatsappTemplates,
      "item-text": "name",
      "item-value": "id",
      "solo": "",
      "outline": ""
    },
    on: {
      "change": function($event) {
        return _vm.fncDisplayTemplate('internal', $event)
      }
    },
    model: {
      value: (_vm.notificationWhatsappTemplate),
      callback: function($$v) {
        _vm.notificationWhatsappTemplate = $$v
      },
      expression: "notificationWhatsappTemplate"
    }
  }), _c('br'), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideInternalTemplate == true),
      expression: "hideInternalTemplate == true"
    }]
  }, [_c('strong', [_vm._v("Saved TWILIO Template:"), _c('br')]), _vm._v(_vm._s(_vm.templateMessageInternal))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideInternalTemplate == true),
      expression: "hideInternalTemplate == true"
    }],
    attrs: {
      "id": "templateMessageInternalHolder"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fncSetTwilioTemplate())
    }
  }), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideInternalTemplate == false),
      expression: "hideInternalTemplate == false"
    }]
  }, [_vm._v("Whatsapp Message")]), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideInternalTemplate == false),
      expression: "hideInternalTemplate == false"
    }],
    attrs: {
      "id": "repSmsText",
      "placeholder": "Create Whatsapp Message",
      "single-line": "",
      "solo": ""
    },
    on: {
      "focus": function($event) {
        return _vm.fncDisablePaste()
      }
    },
    model: {
      value: (_vm.notificationSmsMessage),
      callback: function($$v) {
        _vm.notificationSmsMessage = $$v
      },
      expression: "notificationSmsMessage"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.fncCheckMethodList('sms') && _vm.notifyDaily == false && this.internalSmsPreview == true) ? _c('v-flex', {
    attrs: {
      "lg8": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Whatsapp Message:")]), _vm._v(" "), _c('small', [_c('span', {
    staticStyle: {
      "display": "block !important",
      "float": "left !important"
    }
  }, [_vm._v("Message that will be sent to the rep ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "cursor": "pointer",
      "text-decoration": "underline",
      "display": "block !important",
      "float": "left !important",
      "margin-left": "5px !important"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncShowInternalSmsPreview(false)
      }
    }
  }, [_vm._v("HIDE PREVIEW")])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.fncContentInternalSms())
    }
  })]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 4,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "0px !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fncCheckMethodList('email') || _vm.notifyCustomer == false || _vm.notifyDaily == true),
      expression: "!fncCheckMethodList('email') || notifyCustomer == false || notifyDaily == true"
    }]
  }, [_c('br'), _c('strong', [_vm._v("Please select a Notification Method under the General Tab to enable this screen.")])]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notifyCustomer == true && _vm.fncCheckMethodList('email')),
      expression: "notifyCustomer == true && fncCheckMethodList('email')"
    }],
    staticStyle: {
      "overflow": "hidden !important"
    },
    attrs: {
      "lg4": ""
    }
  }, [_c('v-switch', {
    staticClass: "switchSmall",
    staticStyle: {
      "margin-top": "0px",
      "height": "46px"
    },
    attrs: {
      "label": "Attach the quote PDF"
    },
    model: {
      value: (_vm.notifyAddPdfCustomer),
      callback: function($$v) {
        _vm.notifyAddPdfCustomer = $$v
      },
      expression: "notifyAddPdfCustomer"
    }
  }), _vm._v(" "), (_vm.objAuthorize.so_template != '') ? _c('v-switch', {
    staticClass: "switchSmall",
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "label": "Attach the Sales Order PDF"
    },
    model: {
      value: (_vm.notifyAddPdfSoCustomer),
      callback: function($$v) {
        _vm.notifyAddPdfSoCustomer = $$v
      },
      expression: "notifyAddPdfSoCustomer"
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "blackLabel",
    staticStyle: {
      "margin-top": "15px !important"
    }
  }, [_vm._v("Usable Shortcodes:")]), _vm._v(" "), _c('div', {
    staticClass: "shortcodes"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "12px !important"
    }
  }, [_vm._v("Originator Details")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Sales Rep's first name to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[REP_NAME]', 'customer')
      }
    }
  }, [_vm._v("[REP_NAME]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Sales Rep's surname to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[REP_SURNAME]', 'customer')
      }
    }
  }, [_vm._v("[REP_SURNAME]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Sales Rep's email address to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[REP_EMAIL]', 'customer')
      }
    }
  }, [_vm._v("[REP_EMAIL]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Sales Rep's telephone number to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[REP_TEL]', 'customer')
      }
    }
  }, [_vm._v("[REP_TEL]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add your business name to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[YOUR_COMPANY_NAME]', 'customer')
      }
    }
  }, [_vm._v("[YOUR_COMPANY_NAME]")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-size": "12px !important",
      "margin-top": "20px !important"
    }
  }, [_vm._v("Quote Details")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the quote date to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_DATE]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_DATE]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the quote number to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_NO]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_NO]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the current quote status to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_STATUS]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_STATUS]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add a summary of the quote to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_SUMMARY]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_SUMMARY]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the quote total Exclusive to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_TOTAL_VATEXCL]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_TOTAL_VATEXCL]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the quote total including vat to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_TOTAL_VATINCL]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_TOTAL_VATINCL]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add buttons for the customer to Accept/Reject a quote to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_ACCEPT_REJECT]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_ACCEPT_REJECT]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Transaction ID"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[TRANSACTION_ID]', 'customer')
      }
    }
  }, [_vm._v("[TRANSACTION_ID]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Shipping Tracking Number"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[SHIPPING_TRACKING_NO]', 'customer')
      }
    }
  }, [_vm._v("[SHIPPING_TRACKING_NO]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Shipping Tracking Url"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[SHIPPING_TRACKING_URL]', 'customer')
      }
    }
  }, [_vm._v("[SHIPPING_TRACKING_URL]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Shipping Date / Time"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[SHIPPING_DATE_TIME]', 'customer')
      }
    }
  }, [_vm._v("[SHIPPING_DATE_TIME]")])]), _vm._v(" "), _c('div', {
    staticClass: "shortcodes"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "12px !important"
    }
  }, [_vm._v("Customer Details")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Customer's first name to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[CUSTOMER_NAME]', 'customer')
      }
    }
  }, [_vm._v("[CUSTOMER_NAME]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Customer's surname to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[CUSTOMER_SURNAME]', 'customer')
      }
    }
  }, [_vm._v("[CUSTOMER_SURNAME]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Customer's email address to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[CUSTOMER_EMAIL]', 'customer')
      }
    }
  }, [_vm._v("[CUSTOMER_EMAIL]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Customer's telephone number to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[CUSTOMER_TEL]', 'customer')
      }
    }
  }, [_vm._v("[CUSTOMER_TEL]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Customer's company to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[CUSTOMER_COMPANY]', 'customer')
      }
    }
  }, [_vm._v("[CUSTOMER_COMPANY]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Customer's Delivery Details to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[CUSTOMER_DELIVERY_DETAILS]', 'customer')
      }
    }
  }, [_vm._v("[CUSTOMER_DELIVERY_DETAILS]")]), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Customer Recipient to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_CUSTOMER_RECIPIENT]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_CUSTOMER_RECIPIENT]")]) : _vm._e(), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-size": "12px !important",
      "margin-top": "20px !important"
    }
  }, [_vm._v("Quote Details")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the commercial kam"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_COMMERCIAL_KAM]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_COMMERCIAL_KAM]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the commercial kam"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_COMMERCIAL_COORDINATOR]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_COMMERCIAL_COORDINATOR]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the sales order number"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[SALES_ORDER_NUMBER]', 'customer')
      }
    }
  }, [_vm._v("[SALES_ORDER_NUMBER]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Service Form type"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[SERVICE_TYPE]', 'customer')
      }
    }
  }, [_vm._v("[SERVICE_TYPE]")]), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the sales order number to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_SO_NUMBER]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_SO_NUMBER]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the purchase order number to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_PO_NUMBER]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_PO_NUMBER]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the store to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_STORE]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_STORE]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the status reason to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_STATUS_REASON]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_STATUS_REASON]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the time the status has not changed"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[QUOTE_TIME_IN_STATUS]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_TIME_IN_STATUS]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Company"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[COMPANY]', 'customer')
      }
    }
  }, [_vm._v("[COMPANY]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Project"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[PROJECT]', 'customer')
      }
    }
  }, [_vm._v("[PROJECT]")]) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add the Department"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcode('[DEPARTMENT]', 'customer')
      }
    }
  }, [_vm._v("[DEPARTMENT]")]) : _vm._e()])], 1), _vm._v(" "), (_vm.notifyCustomer == true && _vm.fncCheckMethodList('email') && this.customerEmailPreview == false) ? _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel",
    staticStyle: {
      "display": "block",
      "float": "left",
      "width": "10% !important",
      "padding-top": "10px"
    }
  }, [_vm._v("* Subject:")]), _vm._v(" "), _c('v-text-field', {
    staticStyle: {
      "display": "block",
      "float": "left",
      "width": "45% !important"
    },
    attrs: {
      "placeholder": "Subject",
      "single-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.notificationCustomerSubject),
      callback: function($$v) {
        _vm.notificationCustomerSubject = $$v
      },
      expression: "notificationCustomerSubject"
    }
  }), _vm._v(" "), _c('small', {
    staticStyle: {
      "display": "block",
      "float": "left",
      "width": "30% !important",
      "padding-top": "12px !important"
    }
  }, [_vm._v("  Subject line of the Email")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "blackLabel",
    staticStyle: {
      "margin-top": "20px !important"
    }
  }, [_vm._v("* Create Message Text:")]), _vm._v(" "), _c('small', [_vm._v("Set up the message that will be sent to the Customer.  Insert the shortcode variables into your message template by clicking on them from the desired part of your text. "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "cursor": "pointer",
      "text-decoration": "underline"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncShowCustomerEmailPreview(true)
      }
    }
  }, [_vm._v("VIEW EXAMPLE")])]), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CAN_PASTE_NOTIFICATIONS') == -1) ? _c('v-text-field', {
    attrs: {
      "rows": "10",
      "placeholder": "Customer Email Text",
      "id": "customerText",
      "multi-line": "",
      "solo": ""
    },
    on: {
      "focus": function($event) {
        return _vm.fncDisablePaste()
      }
    },
    model: {
      value: (_vm.customerWysiwig),
      callback: function($$v) {
        _vm.customerWysiwig = $$v
      },
      expression: "customerWysiwig"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CAN_PASTE_NOTIFICATIONS') != -1) ? _c('v-text-field', {
    attrs: {
      "rows": "10",
      "placeholder": "Customer Email Text",
      "id": "customerText",
      "multi-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.customerWysiwig),
      callback: function($$v) {
        _vm.customerWysiwig = $$v
      },
      expression: "customerWysiwig"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.notifyCustomer == true && _vm.fncCheckMethodList('email') && this.customerEmailPreview == true) ? _c('v-flex', {
    attrs: {
      "lg6": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Message:")]), _vm._v(" "), _c('small', [_c('span', {
    staticStyle: {
      "display": "block !important",
      "float": "left !important"
    }
  }, [_vm._v("Message that will be sent to the customer")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "cursor": "pointer",
      "text-decoration": "underline",
      "display": "block !important",
      "float": "left !important",
      "margin-left": "5px !important"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncShowCustomerEmailPreview(false)
      }
    }
  }, [_vm._v("HIDE PREVIEW")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "white-space": "pre-line !important"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fncContentCustomerEmail())
    }
  })]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg2": ""
    }
  }, [_c('h3', {
    staticStyle: {
      "font-size": "12px !important",
      "margin-top": "0px !important"
    }
  }, [_vm._v("Add Attachment Categories")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.attachmentCategories,
      "placeholder": "Notification Attachment Categories",
      "item-value": "id",
      "item-text": "name",
      "multiple": "",
      "outline": ""
    },
    model: {
      value: (_vm.notificationUserCats),
      callback: function($$v) {
        _vm.notificationUserCats = $$v
      },
      expression: "notificationUserCats"
    }
  }), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-size": "12px !important",
      "margin-top": "00px !important"
    }
  }, [_vm._v("Add Roles Shortcode")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.userRoles,
      "placeholder": "Notification User Roles",
      "item-value": "id",
      "item-text": "name",
      "solo": ""
    },
    on: {
      "input": _vm.fncSetRoleUser
    },
    model: {
      value: (_vm.shortRoleUser),
      callback: function($$v) {
        _vm.shortRoleUser = $$v
      },
      expression: "shortRoleUser"
    }
  }), _vm._v(" "), (_vm.notifyDaily === false) ? _c('v-switch', {
    staticClass: "switchSmall pdfSwitch",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "label": "Attach the full service form"
    },
    model: {
      value: (_vm.attachServiceFormFullCustomer),
      callback: function($$v) {
        _vm.attachServiceFormFullCustomer = $$v
      },
      expression: "attachServiceFormFullCustomer"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('v-switch', {
    staticClass: "switchSmall pdfSwitch",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "label": "Attach the customer service form"
    },
    model: {
      value: (_vm.attachServiceFormClientCustomer),
      callback: function($$v) {
        _vm.attachServiceFormClientCustomer = $$v
      },
      expression: "attachServiceFormClientCustomer"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.notifyDaily === false) ? _c('v-switch', {
    staticClass: "switchSmall pdfSwitch",
    staticStyle: {
      "margin-top": "0px"
    },
    attrs: {
      "label": "Attach Delivery Note"
    },
    model: {
      value: (_vm.attachDeliveryNoteCustomer),
      callback: function($$v) {
        _vm.attachDeliveryNoteCustomer = $$v
      },
      expression: "attachDeliveryNoteCustomer"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 5,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "0px !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fncCheckMethodList('sms') || _vm.notifyCustomer == false || _vm.notifyDaily == true),
      expression: "!fncCheckMethodList('sms') || notifyCustomer == false || notifyDaily == true"
    }]
  }, [_c('br'), _c('strong', [_vm._v("Please select a Notification Method under the General Tab to enable this screen.")])]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notifyCustomer == true && _vm.fncCheckMethodList('sms')),
      expression: "notifyCustomer == true && fncCheckMethodList('sms')"
    }],
    staticStyle: {
      "overflow": "hidden !important"
    },
    attrs: {
      "lg4": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Usable Shortcodes:")]), _vm._v(" "), _c('div', {
    staticClass: "shortcodes"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "12px !important"
    }
  }, [_vm._v("Originator Details")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Sales Rep's first name to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[REP_NAME]', 'customer')
      }
    }
  }, [_vm._v("[REP_NAME]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Sales Rep's surname to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[REP_SURNAME]', 'customer')
      }
    }
  }, [_vm._v("[REP_SURNAME]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Sales Rep's email address to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[REP_EMAIL]', 'customer')
      }
    }
  }, [_vm._v("[REP_EMAIL]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Sales Rep's telephone number to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[REP_TEL]', 'customer')
      }
    }
  }, [_vm._v("[REP_TEL]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add your business name to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[YOUR_COMPANY_NAME]', 'customer')
      }
    }
  }, [_vm._v("[YOUR_COMPANY_NAME]")])]), _vm._v(" "), _c('div', {
    staticClass: "shortcodes"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "12px !important"
    }
  }, [_vm._v("Customer Details")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Customer's first name to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[CUSTOMER_NAME]', 'customer')
      }
    }
  }, [_vm._v("[CUSTOMER_NAME]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Customer's surname to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[CUSTOMER_SURNAME]', 'customer')
      }
    }
  }, [_vm._v("[CUSTOMER_SURNAME]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Customer's email address to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[CUSTOMER_EMAIL]', 'customer')
      }
    }
  }, [_vm._v("[CUSTOMER_EMAIL]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Customer's telephone number to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[CUSTOMER_TEL]', 'customer')
      }
    }
  }, [_vm._v("[CUSTOMER_TEL]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the Customer's company to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[CUSTOMER_COMPANY]', 'customer')
      }
    }
  }, [_vm._v("[CUSTOMER_COMPANY]")])]), _vm._v(" "), _c('div', {
    staticClass: "shortcodes"
  }, [_c('h3', {
    staticStyle: {
      "font-size": "12px !important",
      "margin-top": "20px !important"
    }
  }, [_vm._v("Quote Details")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the quote date to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[QUOTE_DATE]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_DATE]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the quote number to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[QUOTE_NO]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_NO]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the current quote status to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[QUOTE_STATUS]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_STATUS]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the quote total Exclusive to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[QUOTE_TOTAL_VATEXCL]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_TOTAL_VATEXCL]")]), _vm._v(" "), _c('div', {
    attrs: {
      "title": "Add the quote vat total to the message"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[QUOTE_TOTAL_VATINCL]', 'customer')
      }
    }
  }, [_vm._v("[QUOTE_TOTAL_VATINCL]")]), _vm._v(" "), (_vm.notifyDaily === false) ? _c('div', {
    attrs: {
      "title": "Add Quote PDF Download Button"
    },
    on: {
      "click": function($event) {
        return _vm.fncSetShortcodeSms('[DOWNLOAD_BUTTON]', 'customer')
      }
    }
  }, [_vm._v("[DOWNLOAD_BUTTON]")]) : _vm._e()])]), _vm._v(" "), (_vm.notifyCustomer == true && _vm.fncCheckMethodList('sms') && this.customerSmsPreview == false) ? _c('v-flex', {
    attrs: {
      "lg8": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* Create Whatsapp Message:")]), _c('br'), _vm._v(" "), _c('label', [_vm._v("Select Whatsapp Template")]), _vm._v(" "), _c('v-select', {
    staticClass: "shortSelect",
    attrs: {
      "placeholder": "Select Whatsapp Template",
      "items": _vm.whatsappTemplates,
      "item-text": "name",
      "item-value": "id",
      "solo": "",
      "outline": ""
    },
    on: {
      "change": function($event) {
        return _vm.fncDisplayTemplate('customer', $event)
      }
    },
    model: {
      value: (_vm.notificationWhatsappTemplateCustomer),
      callback: function($$v) {
        _vm.notificationWhatsappTemplateCustomer = $$v
      },
      expression: "notificationWhatsappTemplateCustomer"
    }
  }), _c('br'), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideCustomerTemplate == true),
      expression: "hideCustomerTemplate == true"
    }]
  }, [_c('strong', [_vm._v("Saved TWILIO Template:"), _c('br')]), _vm._v(_vm._s(_vm.templateMessageCustomer))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideCustomerTemplate == true),
      expression: "hideCustomerTemplate == true"
    }],
    attrs: {
      "id": "templateMessageCustomerHolder"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fncSetTwilioTemplateCustomer())
    }
  }), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideCustomerTemplate == false),
      expression: "hideCustomerTemplate == false"
    }]
  }, [_vm._v("Whatsapp Message")]), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideCustomerTemplate == false),
      expression: "hideCustomerTemplate == false"
    }],
    attrs: {
      "id": "customerSmsText",
      "placeholder": "Create Whatsapp Message",
      "single-line": "",
      "solo": ""
    },
    on: {
      "focus": function($event) {
        return _vm.fncDisablePaste()
      }
    },
    model: {
      value: (_vm.notificationCustomerSmsMessage),
      callback: function($$v) {
        _vm.notificationCustomerSmsMessage = $$v
      },
      expression: "notificationCustomerSmsMessage"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.notifyCustomer == true && _vm.fncCheckMethodList('sms') && this.customerSmsPreview == true) ? _c('v-flex', {
    attrs: {
      "lg8": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("* SMS Message:")]), _vm._v(" "), _c('small', [_c('span', {
    staticStyle: {
      "display": "block !important",
      "float": "left !important"
    }
  }, [_vm._v("Message that will be sent to the customer ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "cursor": "pointer",
      "text-decoration": "underline",
      "display": "block !important",
      "float": "left !important",
      "margin-left": "5px !important"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncShowCustomerSmsPreview(false)
      }
    }
  }, [_vm._v("HIDE PREVIEW")])]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.fncContentCustomerSms())
    }
  })]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    key: 6,
    staticClass: "pl-4 pr-4 pt-4 pb-4"
  }, [_c('v-container', {
    staticStyle: {
      "padding-top": "0px !important"
    },
    attrs: {
      "grid-list-xl": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("API Auth Token:")]), _vm._v(" "), _c('small', [_vm._v("Does this API call need an Autorization token?")]), _vm._v(" "), _c('v-switch', {
    model: {
      value: (_vm.apiData.apiAuth),
      callback: function($$v) {
        _vm.$set(_vm.apiData, "apiAuth", $$v)
      },
      expression: "apiData.apiAuth"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [(_vm.apiData.apiAuth == true || _vm.apiData.apiAuth == 'true') ? _c('div', [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("API Auth Variable Type:")]), _vm._v(" "), _c('small', [_vm._v("What kind of variables does the auth token receive?")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.apiAuthDataTypes,
      "placeholder": "Auth Data Type",
      "item-value": "id",
      "item-text": "name",
      "solo": ""
    },
    model: {
      value: (_vm.apiData.apiAuthDataType),
      callback: function($$v) {
        _vm.$set(_vm.apiData, "apiAuthDataType", $$v)
      },
      expression: "apiData.apiAuthDataType"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [(_vm.apiData.apiAuth == true || _vm.apiData.apiAuth == 'true') ? _c('div', [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("API Auth URL:")]), _vm._v(" "), _c('small', [_vm._v("URL for the api auth?")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "URL for Auth Call",
      "solo": ""
    },
    model: {
      value: (_vm.apiData.apiAuthUrl),
      callback: function($$v) {
        _vm.$set(_vm.apiData, "apiAuthUrl", $$v)
      },
      expression: "apiData.apiAuthUrl"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [(_vm.apiData.apiAuth == true || _vm.apiData.apiAuth == 'true') ? _c('div', [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("API Auth Variables:")]), _vm._v(" "), _c('small', [_vm._v("If JSON paste JSON, else comma deliminated list like id: value, id: value")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rows": "5",
      "placeholder": "JSON for Auth Call",
      "multi-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.apiData.apiAuthData),
      callback: function($$v) {
        _vm.$set(_vm.apiData, "apiAuthData", $$v)
      },
      expression: "apiData.apiAuthData"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("API Variable Type:")]), _vm._v(" "), _c('small', [_vm._v("What kind of variables does the auth token receive?")]), _vm._v(" "), _c('v-select', {
    staticClass: "dropdown",
    attrs: {
      "items": _vm.apiDataTypes,
      "placeholder": "Auth Data Type",
      "item-value": "id",
      "item-text": "name",
      "solo": ""
    },
    model: {
      value: (_vm.apiData.apiDataType),
      callback: function($$v) {
        _vm.$set(_vm.apiData, "apiDataType", $$v)
      },
      expression: "apiData.apiDataType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("API URL:")]), _vm._v(" "), _c('small', [_vm._v("URL for the api?")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "URL for Auth Call",
      "solo": ""
    },
    model: {
      value: (_vm.apiData.apiUrl),
      callback: function($$v) {
        _vm.$set(_vm.apiData, "apiUrl", $$v)
      },
      expression: "apiData.apiUrl"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("API Variables:")]), _vm._v(" "), _c('small', [_vm._v("If JSON paste JSON, else comma deliminated list like id: value, id: value")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rows": "5",
      "placeholder": "JSON for Auth Call",
      "multi-line": "",
      "solo": ""
    },
    model: {
      value: (_vm.apiData.apiData),
      callback: function($$v) {
        _vm.$set(_vm.apiData, "apiData", $$v)
      },
      expression: "apiData.apiData"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg3": ""
    }
  }, [_c('label', {
    staticClass: "blackLabel"
  }, [_vm._v("Usable Shortcodes:")]), _vm._v(" "), _c('small', [_vm._v("Please copy and paste")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("[AUTH_TOKEN]")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("[QUOTE_NO]")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("[QUOTE_ID]")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    attrs: {
      "color": "success"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fncCloseButtonText())
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (_vm.runAdd) ? _c('v-progress-circular', {
    staticClass: "pt-3 loginLoader",
    attrs: {
      "indeterminate": "",
      "width": 3,
      "size": 20,
      "color": "grey"
    }
  }) : _vm._e()], 1)])], 1)], 1)], 1)
},staticRenderFns: []}